import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { ActeConsultationItem } from 'src/app/entities/consultation.entity';

export class ActesFilter {
  acteConsultation: ActeConsultationItem;
  selected: boolean;
  index: number;
  constructor(other?: Partial<ActesFilter>) {
    this.acteConsultation =
      other?.acteConsultation || new ActeConsultationItem();
    this.selected = other?.selected || false;
    this.index = other?.index || 0;
  }
}

@Component({
  selector: 'app-act-select-drawer',
  templateUrl: './act-select-drawer.component.html',
  styleUrls: ['./act-select-drawer.component.css'],
})
export class ActSelectDrawerComponent implements OnInit, OnChanges {
  @Input() values: Array<any> = new Array();
  @Output() valuesChange: EventEmitter<any> = new EventEmitter();
  isChecked: boolean = false;
  actes: string = '';
  familleActe: string = '';
  select: Array<ActesFilter> = [];
  @Input() actesSelected: Array<ActesFilter> = new Array();
  @Output() actesSelectedChange: EventEmitter<Array<ActesFilter>> =
    new EventEmitter();
  @Output() closed: EventEmitter<void> = new EventEmitter();
  famillesUniques: string[] = [];
  constructor() {}
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['values'] && changes['values'].currentValue) {
      this.extraireFamillesUniques();
    }
  }

  ngOnInit(): void {
    this.extraireFamillesUniques();
  }

  extraireFamillesUniques(): void {
    if (!this.values || this.values.length === 0) {
      this.famillesUniques = [];
      return;
    }

    const familles = this.values
      .map((act) => {
        if (act.actes && act.actes.famille_Acte) {
          return act.actes.famille_Acte;
        }
        return null;
      })
      .filter(
        (famille) =>
          famille !== null &&
          famille !== undefined &&
          famille !== '' &&
          typeof famille === 'string'
      );

    this.famillesUniques = [...new Set(familles)].sort();
  }

  changed(acte: any, event, index): void {
    if (event.target.checked == true) {
      this.actesSelected.push({
        acteConsultation: new ActeConsultationItem({ act: acte }),
        selected: event.target.checked,
        index: index,
      });
      this.actesSelectedChange.emit(
        this.actesSelected.filter(
          (elm) => elm.acteConsultation.act.desc_Acte !== ''
        )
      );
    } else {
      this.actesSelected = this.actesSelected.filter(
        (elm) => elm.acteConsultation.act !== acte && elm.selected != false
      );
      this.actesSelectedChange.emit(this.actesSelected);
    }
  }

  close(): void {
    this.actesSelectedChange.emit(this.actesSelected);
    this.closed.emit();
  }
}
